module.exports = __webpack_public_path__ + "img/botella_black_2.0bbaf12b.jpeg";